import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@base-app';
import { SampleTitleProps } from './SampleTitle.types';
import { Permissions } from '@/modules/permissions/types';
import RequirePermission from '@modules/permissions/components/RequirePermission/RequirePermission';
import { STUDY_INSIGHTS_TRANSLATION } from '@modules/study-insights/constants';
import {
  StlyledSampleTitleContainer,
  StyledContent,
  StyledIconContainer,
  StyledRightArrowIcon,
  StyledRightLabel,
} from './SampleTitle.styles';

const SampleTitle: FC<SampleTitleProps> = ({ icon, id, label, onClickViewOrderIds }) => {
  const { t } = useTranslation(STUDY_INSIGHTS_TRANSLATION);

  return (
    <StlyledSampleTitleContainer data-testid={`${id}-sample-title`}>
      <StyledContent>
        {icon && <StyledIconContainer data-testid={`${id}-sample-title-icon`}>{icon}</StyledIconContainer>}
        <Box data-testid={`${id}-sample-title-label`}>{label}</Box>
      </StyledContent>
      <RequirePermission to={Permissions.CAN_VIEW_PHI}>
        <StyledRightLabel data-testid={`${id}-view-order-ids-btn`} onClick={onClickViewOrderIds}>
          {t('view_order_id.label_btn')}
          <StyledRightArrowIcon />
        </StyledRightLabel>
      </RequirePermission>
    </StlyledSampleTitleContainer>
  );
};

export default SampleTitle;
